var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosePurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14369_3330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9903 11.9547L23.1849 4.75946C23.652 4.22904 23.8994 3.54083 23.8768 2.83471C23.8543 2.12858 23.5634 1.45754 23.0634 0.957975C22.5634 0.458414 21.8917 0.167828 21.1849 0.145284C20.4781 0.122739 19.7893 0.369927 19.2584 0.836604L12.0564 8.02448L4.84147 0.814368C4.58305 0.556181 4.27625 0.351377 3.9386 0.211647C3.60095 0.0719178 3.23906 2.72044e-09 2.87359 0C2.50812 -2.72044e-09 2.14623 0.0719178 1.80858 0.211647C1.47093 0.351377 1.16414 0.556181 0.90571 0.814368C0.647284 1.07255 0.44229 1.37907 0.30243 1.7164C0.162571 2.05374 0.0905868 2.41529 0.0905868 2.78043C0.0905868 3.14556 0.162571 3.50711 0.30243 3.84445C0.44229 4.18179 0.647284 4.4883 0.90571 4.74648L8.12251 11.9547L0.927967 19.1482C0.64581 19.4002 0.418079 19.707 0.258708 20.05C0.0993367 20.3929 0.0116763 20.7647 0.00108895 21.1427C-0.00949844 21.5207 0.05721 21.8968 0.197133 22.2481C0.337057 22.5994 0.547253 22.9185 0.814862 23.1859C1.08247 23.4533 1.40187 23.6633 1.75351 23.803C2.10514 23.9428 2.48164 24.0095 2.85994 23.9989C3.23825 23.9883 3.61042 23.9008 3.95369 23.7415C4.29695 23.5823 4.60409 23.3548 4.85631 23.0729L12.0564 15.885L19.2491 23.0729C19.771 23.5943 20.4789 23.8873 21.217 23.8873C21.9551 23.8873 22.663 23.5943 23.1849 23.0729C23.7068 22.5515 24 21.8442 24 21.1068C24 20.3694 23.7068 19.6622 23.1849 19.1408L15.9903 11.9547Z",
    fill: "#6FA0FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14369_3330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosePurple);
export default __webpack_public_path__ + "static/media/close-purple.7f5515e516cb441130b3b4d1b6ecae4e.svg";
export { ForwardRef as ReactComponent };